import { action } from 'easy-peasy';
import initStore, { createDefaultClientsFilters } from '../initStore';
import { IActionResetClientStore } from '../types';

const resetClientStore: IActionResetClientStore = action(state => {
  state.current = initStore.current;
  state.list = initStore.list;
  state.filters = createDefaultClientsFilters();
  state.clientOptionsByTeam = initStore.clientOptionsByTeam;
  state.defaultClient = initStore.defaultClient;
  state.medicaidPlan = initStore.medicaidPlan;
  state.medicaidHistory = initStore.medicaidHistory;
  state.availableClients = initStore.availableClients;
});

export default resetClientStore;
